import Vue from 'vue'
import store from '@/store/store'
import axios from '@/axios.js'

store.subscribe((mutation) => {
    switch (mutation.type) {
        case 'auth/SET_TOKEN':
            if(mutation.payload){
                axios.defaults.headers.common['Authorization'] = `Bearer ${mutation.payload}`    
                // localStorage.setItem('token', mutation.payload)    
                console.log('token', mutation.payload);
                Vue.$cookies.set('token', mutation.payload,'24h')       
            }else{
                axios.defaults.headers.common['Authorization'] = null
                // localStorage.removeItem('token')
                console.log("remove cookie");
                Vue.$cookies.remove('token')
            }
            break;
        case 'auth/SET_ROLE':
            if(mutation.payload){
                Vue.$cookies.set('role', mutation.payload,'24h')
            }else{
                Vue.$cookies.remove('role')
            }
            break;
        case 'auth/REMOVE_TOKEN':
            console.log('auth/REMOVE_TOKEN');
            axios.defaults.headers.common['Authorization'] = null
            Vue.$cookies.remove('token')
            break;
    
        default:
            break;
    }
})

store.subscribeAction({
    before: (action, state) => {
        if(action.type !== 'auth/login'){
            if(!!!Vue.$cookies.get('token')){
                axios.defaults.headers.common['Authorization'] = null
            }
        }
    }
})